export const aciStay = {
    iconName: 'stay',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: [
            {
                attr: {
                    'clip-rule': 'evenodd',
                    d: 'M.75 5.25a1.5 1.5 0 011.5-1.5h19.5a1.5 1.5 0 011.5 1.5v16.5a1.5 1.5 0 01-1.5 1.5H2.25a1.5 1.5 0 01-1.5-1.5V5.25z',
                    stroke: 'currentColor',
                    'stroke-width': '1.5',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M.75 9.75h22.5M6.75 6V.75M17.25 6V.75M5.625 13.5a.375.375 0 100 .75.375.375 0 000-.75M5.625 18.75a.375.375 0 100 .75.375.375 0 000-.75M12 13.5a.375.375 0 100 .75.375.375 0 000-.75M12 18.75a.375.375 0 100 .75.375.375 0 000-.75M18.375 13.5a.375.375 0 100 .75.375.375 0 000-.75M18.375 18.75a.375.375 0 100 .75.375.375 0 000-.75',
                    stroke: 'currentColor',
                    'stroke-width': '1.5',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
        ],
    },
};
